import { density } from './mmwaveprotocol';

// This file just exports aliases to protocol namespaces

// This one is badly named, but kept for backward compatibility
export import protocol = density.protocol.openarea.v1;

export import openarea = density.protocol.openarea;
export import sensors = density.sensors;
